/* global customElements, fetch */

import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../service/service.js';
import {ElementUtil} from '../utils/elementUtil.js';
import {SessionStorageUtil} from '../utils/browserStorageSanitizer.js';
import {BaseComponent} from './basecomponent.js';

class UserMenu extends BaseComponent {
	
	static get properties() {
		return {
			menuName: {type: String}
		};
	}

	constructor() {
		super();
		this.menuName = '';
		
		var userMenu = this;
		setTimeout(function(){
			userMenu.init();
		});
	}
	
	render() {	
		return html`
			<vaadin-menu-bar theme="primary" class="menu-button">
			</vaadin-menu-bar>
		`;
	}
	
	init() {
		var userMenu = this;
		
		customElements.whenDefined('vaadin-menu-bar').then(function() {
			var menuButton = userMenu.shadowRoot.querySelector("vaadin-menu-bar");			
			menuButton.addEventListener('item-selected', function (e) {
				var menuItem = e.detail.value;
				if (menuItem.handler) {
					menuItem.handler();
				}
			});
			Service.getUserService().getCurrentUser().then(function(user) {
				userMenu.menuButton = menuButton;
				
				var menuItems = [
					{
						component: ElementUtil.makeMenuIcon('vaadin:building', ' Current Company'),
						handler: function() {
							actionShowCurrentCompany(user);
						}
					},
					{component: 'hr'}
				];
				
				if (user.companies.length > 1) {
					
					menuItems.push({
						component: ElementUtil.makeMenuIcon('vaadin:office', ' Switch Companies'),
						handler: function() {	
							actionSwitchCompanies(user);
						}
					});
					menuItems.push({
						component: 'hr'
					});
				}
				
				menuButton.items = [	
					{
						text: user.userProfile.firstname + ' ' + user.userProfile.lastname,
						children: 
							menuItems.concat([	
							{
								component: ElementUtil.makeMenuIcon('lumo:user', ' User Settings'),
								handler: function() {	
									actionUserProfile();
								}
							},
							{component: 'hr'},
							{
								component: ElementUtil.makeMenuIcon('vaadin:question-circle', ' Help'),
								handler: function() {	
									actionHelp();
								}
							},
							{
								component: ElementUtil.makeMenuIcon('vaadin:comment', ' Contact'),
								handler: function() {	
									actionContact();
								}
							},							
							{component: 'hr'},
							{ 
								component: ElementUtil.makeMenuIcon('vaadin:sign-out', ' Logout'),
								handler: function() {
									var loadMask = window.DL.MessageUtil.fullPageLoadMask('<i class="fas fa-cog fa-spin fa-2x"></i>Logging out..', true);
									fetch('/logout', {
										method: 'POST',
										credentials: 'same-origin',
										headers: {
											'X-Requested-With': 'XMLHttpRequest'
										}
									}).then(function(response){
										
										if (response.ok) {
											Service.getUserService().clearCurrentUser();
											Service.getCompanyService().clearWorkingCompany();											
											if (user.ssoUser) {
												loadMask.remove();
												window.location.href = '/sso/sso-logout-url?userId='
													+ encodeURIComponent(user.userName);
											} else {
												loadMask.remove();
												//window.location.reload();
												window.location.href = "/";											
											}
//											window.DL.showLogin(function(){
//												window.DL.validLoginProceed();
//											});
										} else {
											loadMask.remove();																		
											var errorMessage = 'Unable to logout.  Check network connection and try again.<br>' + response.status + ' - ' + response.statusText ;
											window.DL.MessageUtil.showToastError(errorMessage);
										}
									});
								}
							}
						])
					}
				];
				
				var backgroundColor = userMenu.getBackgroundColor();
							
				menuButton.shadowRoot.append(ElementUtil.create({
					tag: 'style',
					innerHTML: `
						.menu-button {
							background-color: ${backgroundColor} !important;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
							max-width: 100%;
						}

						vaadin-menu-bar-button {
							max-width: 100%;
							overflow: hidden;
							text-overflow: ellipsis;
						}

						@media only screen and (max-width: 600px) {
							.menu-button {
								background-color: ${backgroundColor} !important;
								font-size: 13px !important;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
								max-width: 110px;
							}

							vaadin-menu-bar-button {
								max-width: 110px;
							}
						}
					`
				}));
				
				//menuButton.shadowRoot.querySelector('vaadin-menu-bar-button').setAttribute('class', 'menu-button');
				
			});
						
		});
		
//		async function getSSOLogoutURL(userId) {
//			const res = await fetch("/sso/sso-logout-url?userId=" + encodeURIComponent(userId), {
//				cache: 'no-cache',
//				headers: {
//					'Authorization': ''
//				}
//			});
//			var logoutURL = await res.text();
//			return logoutURL;
//		};	
		
		var buildCompanySummaryHtml = function(companyAll, user) {
			var workingCompanyId = SessionStorageUtil.getItem('workingCompany');
			var isWorkingAs = workingCompanyId || (user.primaryCompany && companyAll.company.companyId !== user.primaryCompany.companyId);
			var headline = isWorkingAs
				? 'Working as ' + companyAll.company.companyName
				: companyAll.company.companyName;

			var details = [];
			if (companyAll.company.companyId != null && String(companyAll.company.companyId).trim() !== '') {
				details.push('<b>Company Id:</b> ' + companyAll.company.companyId);
			}
			if (companyAll.company.referenceCode != null && String(companyAll.company.referenceCode).trim() !== '') {
				details.push('<b>Reference:</b> ' + companyAll.company.referenceCode);
			}
			if (companyAll.company.carrierId != null && String(companyAll.company.carrierId).trim() !== '') {
				details.push('<b>Carrier Id:</b> ' + companyAll.company.carrierId);
			}
			if (user.primaryCompany && companyAll.company.companyId === user.primaryCompany.companyId) {
				details.push('<b>Primary company</b>');
			}
			var timezone = companyAll.company.baseTimeZone || companyAll.company.serverTimeZone || 'CST6CDT';
			details.push('<b>Company timezone:</b> ' + timezone);

			return '<div style="font-size: 18px; margin-bottom: 12px;">' + headline + '</div>'
				+ '<div style="line-height: 1.6;">' + details.join('<br>') + '</div>';
		};

		var actionShowCurrentCompany = function(user) {
			Service.getCompanyService().getCurrentCompany().then(function(companyAll) {
				var companyWin = ElementUtil.create({
					tag: 'dl-dialog',
					title: 'Current Company',
					icon: 'vaadin:building',
					width: 0.55,
					'mobile-width': 0.9,
					height: 0.28,
					scope: 'app',
					listeners: {
						ready: function() {
							companyWin.show();
							companyWin.addToContentElement(ElementUtil.create({
								tag: 'div',
								style: 'padding: 4px;',
								innerHTML: buildCompanySummaryHtml(companyAll, user)
							}));
						}
					}
				});
			});
		};

		var actionSwitchCompanies = function(user) {
			var companyWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Switch Companies',
				icon: 'vaadin:office',
				width: 0.55,
				'mobile-width': 0.92,
				height: 0.32,
				scope: 'app',
				listeners: {
					ready: function() {						
						companyWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',
									style: 'width: 100%; box-sizing: border-box;',
									children: [																				
										{
											tag: 'vaadin-combo-box',											
											label: 'Company', 
											name: 'companyId',
											required: true,
											style: 'width: 100%;',
											'item-value-path': 'code',
											'item-label-path': 'description',
											postinit: function(combo) {											
												var companyLookups = [];
												user.companies.forEach(function(company){
													var primary = false;
													if (company.companyId === user.primaryCompany.companyId) {
														primary = true;
													}
													var description = company.companyName;
													if (primary) {
														description += ' (primary)';
													} else if (company.temporary) {
														description += ' (temporary)';
													}
													
													companyLookups.push({
														code: company.companyId,
														description: description
													});
												});
												combo.items = companyLookups;
											}
										},														
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:arrow-circle-right', ' Switch')
													],
													listeners: {
														click: function() {															
																
															if (formPanel.isValid()) {
																var data = formPanel.getData();
																
																var primary = false;
																if (data.companyId === user.primaryCompany.companyId) {
																	primary = true;
																}

																//Go from current working company to the new company
																Service.getCompanyService().switchCompanies(data.companyId, primary).then(function(){
																	//this clears the old company and refreshes
																	window.location.replace('/');
																}, function() {
																	console.log('Warning: Failed switch event. Proceeding...');
																	window.location.replace('/');
																});
															}
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															companyWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						companyWin.addToContentElement(formPanel);							
					}
				}
			});
		};		
	
		var actionContact = function() {
			var feedbackWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Contact Us',
				icon: 'vaadin:envelope',
				scope: 'app',
				listeners: {
					ready: function() {
						
						feedbackWin.show();
						
						var feedbackForm = ElementUtil.create({
							tag: 'dl-feedback-form',
							slot: 'primary',
							listeners: {
								success: function() {
									window.DL.MessageUtil.showToast('Success', 'Submitted Feedback', {									
										theme: 'success'
									});
									feedbackWin.close();
								},
								cancel: function() {
									feedbackWin.close();
								}
							}
						});
						
						var flexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [								
								feedbackForm
							]
						});
						
						//allow window finish showing so form can get focus
						setTimeout(function(){
							feedbackWin.addToContentElement(flexLayout);
						}, 10);
						
					}
				}
			});
			
		};	
		
		var actionHelp = function() {

			var helpWin = ElementUtil.create({			
				tag: 'dl-window',
				headertext: '<vaadin-icon icon="vaadin:question-circle"></vaadin-icon> Help',
				modal: false,
				width: '465px',
				left: (window.innerWidth-485) + 'px',
				top: '100px',
				listeners: {
					ready: function() {
						helpWin.show();
						
						var loadHelp = function() {
							var loadMask = helpWin.getContentPanel().showLoading(); 
							var page = window.location.pathname.replace(/\//g, '');
							Service.getHelpService().getHelpPage(page).then(function(data){
								loadMask.remove();
								helpWin.getContentPanel().style.padding = '10px';
								helpWin.getContentPanel().innerHTML = data.content;
							});
						};
						loadHelp();
						
						helpWin.urlListener = function() {
							loadHelp();
						};						
						window.addEventListener('pagechange', helpWin.urlListener);						
					},
					close: function() {
						window.removeEventListener('pagechange', helpWin.urlListener);						
					}
				}
			});
			
		};
		
		var actionUserProfile = function() {
		
			var userWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'User Settings',
				icon: 'vaadin:user',
				scope: 'app',
				listeners: {
					ready: function() {						
						userWin.show();
						
						var tabPanel = ElementUtil.create({
							tag: 'dl-tabpanel',
							slot: 'primary',
							style: 'height: 100%;',	
							listeners: {
								ready: function() {
									tabPanel.addTabs([
										{
											'tab-title': 'Profile',
											tag: 'div',	
											style: 'width: 99.9%;',
											children: [
												{
													tag: 'dl-user-profile-form',
													itemid: 'profileForm',
													listeners: {
														ready: function() {
															var profileForm = ElementUtil.query(tabPanel, 'profileForm');
															var loadMask = profileForm.showLoading();
															Service.getUserService().getCurrentUser().then(function(currentUser){
																loadMask.remove();
																profileForm.loadUser(currentUser.userProfile);
															});
														},
														saved: function(event) {
															window.location.reload();
														}
													}
												}
											]
										},
										{
											'tab-title': 'Alerts',
											tag: 'div',
											style: 'height: 100%;',
											children: [
												{
													tag: 'dl-alert-grid',
													user: true
												}
											]
										},
										{
											'tab-title': 'Downloads',
											tag: 'div',
											style: 'height: 100%;',
											children: [
												{
													tag: 'dl-backgroundoutput-grid'
												}
											]
										},
										{
											'tab-title': 'Change Password',
											tag: 'div',
											style: 'width: 99.9%;',
											children: [
												{
													tag: 'dl-changepassword-form'													
												}
											]
										}
									]);
									
								}
							}
							
						});
						
						var flexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [								
								tabPanel
							]
						});
						
						//allow window finish showing so form can get focus
						setTimeout(function(){
							userWin.addToContentElement(flexLayout);	
						}, 10);
						
					}
				}
			});
			
		};
		
	}
	
	getBackgroundColor() {
		return window.DL.Branding.menuColor;	
	}
	
};
customElements.define('dl-user-menu', UserMenu);




